/* eslint-disable no-unused-vars */
import { MN, NM } from './constants';

export const ml = (i, startDate = null) => {
  if (startDate) {
    const totalMonths = startDate.month + i;
    const year  = startDate.year + Math.floor(totalMonths / 12);
    const month = totalMonths % 12;
    return MN[month] + ' ' + year;
  }
  return MN[i % 12] + ' Y' + (Math.floor(i / 12) + 1);
};

// No $ symbol — just formatted number with comma separators
export const fu = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '—';
  return (n < 0 ? '(' : '') + Math.round(Math.abs(n)).toLocaleString('en-US') + (n < 0 ? ')' : '');
};

// Percentage with no decimal places
export const fp = (n) =>
  n === null || isNaN(n) ? '—' : Math.round(n) + '%';

// Percentage with 1 decimal place
export const fpd = (n) =>
  n === null || isNaN(n) ? '—' : n.toFixed(1) + '%';

export const A = (v = '') => Array(NM).fill(null).map(() => v);

/**
 * Safe month label that handles negative indices (pre-forecast months).
 * Falls back to startDate-relative if startDate provided.
 */
export const mlSafe = (i, startDate = null) => {
  if (startDate) {
    const totalMonths = startDate.month + i;
    const year  = startDate.year + Math.floor(totalMonths / 12);
    const month = ((totalMonths % 12) + 12) % 12; // handles negative
    return MN[month] + ' ' + year;
  }
  if (i < 0) return `${Math.abs(i)}m pre`;
  return MN[i % 12] + ' Y' + (Math.floor(i / 12) + 1);
};
